export default __webpack_public_path__ + "static/media/PPI-patio-020.27eec0df.jpg";